import Image from "next/image";
import styled, { css } from "styled-components";
import { Button } from "~/guidelines/Button";
import LinkedInIcon from "~/guidelines/Icon/Social/LinkedIn";
import { body2, caption1 } from "~/guidelines/Typography";
import Image1 from "../_assets/team/hugues-van-heesewijk.png";
import Image2 from "../_assets/team/maxime-lesaulnier.png";

const TeamMembersRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 30px;
    flex-direction: column;
    align-items: center;
  }
`;

const MemberCard = styled.div<{ position: "top" | "bottom" }>`
  position: relative;
  border: 10px solid ${({ theme }) => theme.color.background.darkTertiary};
  background-color: ${({ theme }) => theme.color.background.lightSecondary};
  height: 370px;
  aspect-ratio: 1 / 1;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  ${({ position }) =>
    position === "bottom" &&
    css`
      margin-top: 100px;
    `}
  ${({ position }) =>
    position === "top" &&
    css`
      margin-left: 50px;
    `}
`;

const UserInformation = styled.div<{ position: "top" | "bottom" }>`
  ${body2};
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  ${({ position }) =>
    position === "bottom" &&
    css`
      margin-top: auto;
    `}
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${caption1}
`;

const ImageWrapper = styled.div<{ position: "top" | "bottom" }>`
  position: absolute;
  ${({ position }) =>
    position === "bottom" &&
    css`
      top: 70px;
      left: -50px;
    `}
  ${({ position }) =>
    position === "top" &&
    css`
      bottom: 70px;
      right: 50px;
    `}
`;

const TeamDesktop = () => (
  <TeamMembersRow>
    <MemberCard key="Hugues van Heesewijk" position="top">
      <UserInformation position="top">
        Hugues van Heesewijk
        <Button kind="tertiary" href="https://www.linkedin.com/in/huguesvanh/">
          <FlexCenter>
            <LinkedInIcon color="#0A33FF" />
            Linked-In
          </FlexCenter>
        </Button>
      </UserInformation>

      <ImageWrapper position="bottom">
        <Image src={Image1} height={370} alt="Hugues van Heesewijk" />
      </ImageWrapper>
    </MemberCard>

    <MemberCard key="Lesaulnier Maxime" position="bottom">
      <UserInformation position="bottom">
        Maxime Lesaulnier
        <Button
          kind="tertiary"
          href="https://www.linkedin.com/in/lesaulnier-maxime-105b8621/"
        >
          <FlexCenter>
            <LinkedInIcon color="#0A33FF" />
            Linked-In
          </FlexCenter>
        </Button>
      </UserInformation>

      <ImageWrapper position="top">
        <Image src={Image2} height={370} alt="Lesaulnier Maxime" />
      </ImageWrapper>
    </MemberCard>
  </TeamMembersRow>
);

export default TeamDesktop;
